import { createContext, use } from "react";

import type { User } from "@/types/api";

export interface AuthContextValue {
  user: User | null;
  /** True until the initial refresh-cookie exchange settles. */
  isLoading: boolean;
  signIn: (username: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  /** Re-fetch /users/me after a profile mutation so `user` stays current. */
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

/**
 * Deliberately kept in a JSX-free module, separate from <AuthProvider>.
 * A file that exports both a component and a hook breaks React Fast Refresh,
 * which silently degrades the dev loop to full page reloads.
 */
export function useAuth(): AuthContextValue {
  const context = use(AuthContext);
  if (!context) throw new Error("useAuth must be used inside an <AuthProvider>");
  return context;
}
